export default __webpack_public_path__ + "static/media/leads-icon-gereen-img.2b079f1e.svg";